module.exports = __webpack_public_path__ + "img/usdc.c9c38308.svg";